export default __webpack_public_path__ + "static/media/Upload.3c0c0ed1.svg";